import './../../styles/templates/blog.scss';

$(function () {
  // BLOG SLIDER CONTENT
  $(".blog-slider-content__items").each(function () {
    $(this).slick({
      dots: true,
      arrows: true,
      infinite: false,
      adaptiveHeight: true,
      autoplay: false,
      slidesToShow: 4,
      prevArrow: $(this).parent().find('.arrow-icon-chevron-left'),
      nextArrow: $(this).parent().find('.arrow-icon-chevron-right'),
      responsive: [{
        breakpoint: 1021,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '40px'
        }
      }]
    });

    var start, end;
    $(this).find('.blog-item__media').each(function () {
      $(this).on('mousedown', (e) => {
        start = e.pageX;
        $(this).attr("data-link-proxy-disabled", true);
      });

      $(this).on('mouseup', (e) => {
        end = e.pageX;
        var diff = Math.abs(end - start);
        if (diff < 100) {
          $('[data-link-proxy-disabled]').removeAttr("data-link-proxy-disabled");
        }
      });
    });
  });

  $(".blog-slider-content__items").on('afterChange', function (event, slick, currentSlide, nextSlide) {
    var currentSlide = $(this).slick('slickCurrentSlide');
    currentSlide++;
    $(this).parent().find('[slider-curr-slide]').text(currentSlide);
  });
});
